import React, { useState } from 'react';
import '../CSS/ProductCard.css';

const ProductCard = ({ name, price, image, detailimage, description, category }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // SEO-optimized alt text
  const getAltText = () => {
    const altTexts = {
      'MC 01': 'MUSCLECRETE MC 01 concrete coating - professional adhesive solution',
      'MC 02': 'MUSCLECRETE MC 02 professional grade coating - concrete adhesive',
      'MC 03': 'MUSCLECRETE MC 03 advanced protective coating for concrete',
      'MC 04': 'MUSCLECRETE MC 04 industrial strength concrete coating adhesive',
      'MC 05': 'MUSCLECRETE MC 05 high-performance concrete coating solution',
      'MC 500': 'MUSCLECRETE MC 500 premium concrete coating adhesive',
      'MC 55': 'MUSCLECRETE MC 55 specialized concrete coating formula',
      'Block Crete': 'MUSCLECRETE Block Crete - high-quality concrete product',
      'MC Hardner': 'MUSCLECRETE MC Hardner - concrete hardening adhesive agent',
    };
    return altTexts[name] || `${name} from MUSCLECRETE by PAC Corporation`;
  };

  return (
    <>
      <article className="product-card" itemScope itemType="https://schema.org/Product">
        <meta itemProp="brand" content="MUSCLECRETE" />
        <meta itemProp="manufacturer" content="PAC Corporation" />
        
        <div className="product-image-container">
          <img
            src={image}
            alt={getAltText()}
            className="product-img"
            onClick={() => setIsModalOpen(true)}
            title={`View details for ${name}`}
            itemProp="image"
          />
          <span className="product-category" itemProp="category">{category}</span>
        </div>
        <div className="product-info">
          <h2 className="product-name" itemProp="name">{name}</h2>
          <p className="product-description" itemProp="description">{description}</p>
          <p className="product-price" itemProp="offers">{price}</p>
          <button 
            className="view-details-btn"
            onClick={() => setIsModalOpen(true)}
            aria-label={`View detailed information for ${name}`}
          >
            View Details
          </button>
        </div>
      </article>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)} role="dialog" aria-modal="true">
          <div className="modal-content" onClick={(e) => e.stopPropagation()} role="presentation">
            <button 
              className="modal-close" 
              onClick={() => setIsModalOpen(false)}
              aria-label="Close product details modal"
              title="Close details"
            >
              ×
            </button>
            <img 
              src={detailimage} 
              alt={`${getAltText()} - detailed view`}
              className="modal-img" 
            />
            <div className="modal-product-info">
              <h2>{name}</h2>
              <p className="modal-category">Category: {category}</p>
              <p className="modal-description">{description}</p>
              <p className="modal-price">{price}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductCard;
